var _excluded = ["buttonText", "children", "icon", "iconFlipAnimation", "id", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { AnimatePresence, motion } from 'framer-motion';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { ChevronDown } from "../../../icons/index.js";
import Button from "../../basic/Button/Button.js";
var StyledDropdownWrapper = styled.div.withConfig({
  componentId: "CL__sc-w9c319-0"
})(["display:inline-block;position:relative;z-index:", ";"], _ref => {
  var {
    isExpanded
  } = _ref;
  return isExpanded ? '1' : '0';
});
var StyledTriggerButton = styled(Button).withConfig({
  componentId: "CL__sc-w9c319-1"
})(["", ""], _ref2 => {
  var {
    $iconFlipAnimation
  } = _ref2;
  return $iconFlipAnimation && css(["&[aria-haspopup='true'] svg{transition:transform var(--hover-transition) var(--transition-easing);}&[aria-expanded='true'] svg{transform:scaleY(-1);transform-origin:50% 50%;}"]);
});
var DropdownButton = _ref3 => {
  var {
      buttonText,
      children,
      icon = ChevronDown,
      iconFlipAnimation = true,
      id,
      onClick: _onClick
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  var [isExpanded, setIsExpanded] = useState(false);
  var refButton = useRef(null);
  var handleExpandedToggle = () => {
    setIsExpanded(!isExpanded);
  };
  var handleDocumentClick = event => {
    if (refButton.current && refButton.current !== event.target) {
      setIsExpanded(false);
    }
  };
  var handleKeydown = useCallback(event => {
    if (event.key === 'Esc' || event.key === 'Escape') {
      setIsExpanded(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledDropdownWrapper, {
    isExpanded: isExpanded
  }, /*#__PURE__*/React.createElement(StyledTriggerButton, _extends({}, props, {
    $iconFlipAnimation: iconFlipAnimation,
    "aria-expanded": isExpanded,
    "aria-haspopup": "true",
    icon: icon,
    iconPosition: "right",
    id: id,
    onClick: event => {
      if (_onClick) {
        _onClick(event);
      }
      handleExpandedToggle();
    },
    ref: refButton
  }), buttonText), /*#__PURE__*/React.createElement(AnimatePresence, null, isExpanded && /*#__PURE__*/React.createElement(motion.div, {
    animate: {
      opacity: 1,
      scale: 1,
      y: 'var(--spacing-2)'
    },
    exit: {
      opacity: 0,
      scale: 0.95
    },
    initial: {
      opacity: 0,
      scale: 0.95
    },
    style: {
      originX: 0.5,
      originY: 0
    },
    transition: {
      duration: 0.2,
      ease: [0.4, 0.05, 0.33, 0.95]
    }
  }, children)));
};
export default DropdownButton;